import { DocumentRepository } from "../repositories/DocumentRepository";
import { DocumentListFilters, DocumentsResultEntity } from "../entities/Document";

/**
 * Get Pending Documents Use Case
 * Retrieves pending documents with pagination
 */
export class GetPendingDocumentsUseCase {
  constructor(private repository: DocumentRepository) {}

  async execute(
    page: number = 1,
    itemsPerPage: number = 10,
    filters?: DocumentListFilters
  ): Promise<DocumentsResultEntity> {
    // Validate pagination
    if (page < 1) {
      throw new Error("Page number must be at least 1");
    }

    if (itemsPerPage < 1 || itemsPerPage > 100) {
      throw new Error("Items per page must be between 1 and 100");
    }

    const offset = (page - 1) * itemsPerPage;

    return await this.repository.fetchPendingDocuments(
      itemsPerPage,
      offset,
      filters
    );
  }
}
